import { render, staticRenderFns } from "./enterprisesChina.vue?vue&type=template&id=38bd4dd6"
import script from "./enterprisesChina.vue?vue&type=script&lang=js"
export * from "./enterprisesChina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports